const DEALER_EVENT_UUID =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

/** True when the id looks like a Dealer queue/claim event UUID. */
export function isDealerEventUuid(eventId: string): boolean {
  return DEALER_EVENT_UUID.test(eventId.trim());
}

/** Parses a numeric Dealer site id from queue/picker strings. */
export function parseDealerSiteId(siteId: string | undefined): number | null {
  const parsed = Number(siteId);
  if (!Number.isInteger(parsed) || parsed <= 0) {
    return null;
  }
  return parsed;
}
